import { talkToSalesCtaSelectedEvent } from '#pplx/frontend/apps/ask/talk-to-sales/analytics.js';
import { CONTACT_SALES_URL, TALK_TO_SALES_UTM_MEDIUM, TALK_TO_SALES_UTM_SOURCE, } from '#pplx/frontend/apps/ask/talk-to-sales/constants.js';
import { sanitizedOpenWindow } from '#pplx/frontend/common/sanitizedRedirectWindow.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
/**
 * The single seam behind every talk-to-sales CTA. Surface components only
 * render `getHref` and call `openTalkToSales`; when the destination decision
 * lands (scheduler modal, reach-out form + intent endpoint), only this hook
 * changes.
 */
export function useTalkToSalesAction() {
    const { track } = useInstrumentation();
    const destination = 'marketingContactForm';
    const getHref = useCallback(({ surface }) => {
        const url = new URL(CONTACT_SALES_URL);
        url.searchParams.set('utm_source', TALK_TO_SALES_UTM_SOURCE);
        url.searchParams.set('utm_medium', TALK_TO_SALES_UTM_MEDIUM);
        url.searchParams.set('utm_content', surface);
        return url.toString();
    }, []);
    const openTalkToSales = useCallback((args, event) => {
        // Prevent native anchor navigation; the href stays on the anchor for
        // accessibility and open-in-new-tab affordances.
        event?.preventDefault();
        track(talkToSalesCtaSelectedEvent({
            name: 'enterprise talk to sales cta selected',
            data: { surface: args.surface, audience: args.audience, destination },
        }));
        sanitizedOpenWindow(getHref(args));
    }, [track, getHref, destination]);
    return useMemo(() => ({ destination, getHref, openTalkToSales }), [destination, getHref, openTalkToSales]);
}
//# sourceMappingURL=useTalkToSalesAction.js.map